import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './supportchat.module.css';

/**
 * Плавающая кнопка чата поддержки на публичном сайте.
 * Ведёт в раздел поддержки личного кабинета (/panel/tickets);
 * неавторизованных панель сама отправит на OIDC-вход.
 */
const SupportChatButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={styles.fab}
      onClick={() => navigate('/panel/tickets')}
      aria-label="Чат с поддержкой"
    >
      <span className={styles.label}>Поддержка</span>
      <svg className={styles.icon} width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path
          d="M4 6.5A2.5 2.5 0 0 1 6.5 4h13A2.5 2.5 0 0 1 22 6.5v9a2.5 2.5 0 0 1-2.5 2.5H10l-4.6 4v-4H6.5A2.5 2.5 0 0 1 4 15.5v-9z"
          fill="#fff"
        />
        <circle cx="9.5" cy="11" r="1.3" fill="#E17E46" />
        <circle cx="13" cy="11" r="1.3" fill="#E17E46" />
        <circle cx="16.5" cy="11" r="1.3" fill="#E17E46" />
      </svg>
    </button>
  );
};

export default SupportChatButton;
